<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
    <!-- Site wrapper -->
    <div class="wrapper">
        <!-- Navbar -->
        <app-header></app-header>
        <!-- /.navbar -->

        <!-- Main Sidebar Container -->
        <app-sidebar [page]="'settings'" [subPage]="'countries'"></app-sidebar>

        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0">Settings</h1>
                    </div><!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="#">Home</a></li>
                            <li class="breadcrumb-item"><a href="#">Settings</a></li>
                            <li class="breadcrumb-item"><a [routerLink]="['/settings/countries']">Countries</a></li>
                            <li class="breadcrumb-item active">{{countryData.title}}</li>
                        </ol>
                    </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->

            <!-- Main content -->
            <section class="content">
                <div class="container-fluid">
                    <app-module-menu [module]="'settings'" [activeSlug]="'countries'"></app-module-menu>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="mb-3">
                                <div class="card card-primary card-outline">
                                    <div class="card-header">
                                        <h4 class="card-title">
                                            <a [routerLink]="['/settings/countries']" [queryParams]="{back:true}"><i class="fas fa-angle-double-left"></i></a> {{countryData.title}}</h4>
                                        <div class="card-tools" *ngIf="checkService.canWrite('country.areas')">
                                            <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#modal-area-form" (click)="onCancel()">
                                                <i class="fas fa-plus"></i> Add Area
                                            </button>
                                        </div>
                                    </div>
                                <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                            </div> 
                        </div>
                        <div class="modal fade" id="modal-area-form" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canWrite('country.areas') || checkService.canModify('country.areas')">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                <div class="card card-primary card-outline mb-0">
                                    <div class="card-header">
                                        <h4 class="card-title">{{formHeader}}</h4>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="onCancel()"><i class="fas fa-times"></i></button>
                                        </div>
                                    </div>
                                    <!-- form start -->
                                    <form [formGroup]="dataForm">
                                        <div class="card-body">
                                            <div class="form-group">
                                                <label for="state">Area Name</label>
                                                <input type="text" required [ngClass]="(state.invalid && (state.dirty || state.touched)) ? 'form-control is-invalid' : (state.valid)? 'form-control is-valid':'form-control'" formControlName="state" id="state" placeholder="Area Name">
                                                <div *ngIf="state.invalid && (state.dirty || state.touched)" class="invalid-feedback">
                                                    <div *ngIf="state.errors.required">Area name is required</div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- /.card-body -->

                                        <div class="card-footer">
                                            <input type="hidden" formControlName="country" id="country">
                                            <input type="hidden" formControlName="ref" id="ref">
                                            <button type="submit" [disabled]="!dataForm.valid || dataForm.pending || processing" (click)="onCreate()" class="btn btn-primary">{{buttonText}}</button>&nbsp;
                                            <button type="button" data-dismiss="modal" (click)="onCancel()" class="btn btn-default">Cancel</button>
                                        </div>
                                    </form>
                                <!-- /.card-body -->
                                </div>
                            </div>
                        </div>
                        </div>
                        <!-- /.col -->
                        <div class="col-md-12">
                            <div class="card card-primary card-outline">
                                <img [hidden]='!loading' [class]="loading?'mx-auto d-block':''" src="assets/LoadingGIF/Rolling-1s-75px.gif">

                                <!-- Default box -->
                                <div class="card card-solid" [hidden]='loading'>
                                    <div class="card-header">
                                        <h3 class="card-title">
                                            <i class="fas fa-edit"></i>
                                            List All Areas in {{countryData.title}}
                                        </h3>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Area</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let countryRow of countryData.areas;">
                                                    <td>{{countryRow.state}}</td>
                                                    <td>
                                                        <div class="text-right"> 
                                                            <div class="btn-group btn-group-sm">
                                                                <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify('country.areas')" data-toggle="modal" data-target="#modal-area-form" (click)="getEdit(countryRow)">
                                                                    <i class="fas fa-edit"></i>
                                                                </button>
                                                                <button type="button" class="btn btn-danger" title="Delete" *ngIf="checkService.canModify('country.areas')" data-toggle="modal" data-target="#modal-delete" (click)="getDataFromList(countryRow.state, countryRow.ref)">
                                                                    <i class="fas fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="countryData.areas.length == 0">
                                                    <td colspan="6" class="text-center">No record to show</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>Area</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <!-- /.card-body -->
                                </div>
                            </div>
                        <!-- /.card -->
                        </div>
                        <!-- /.col -->
                    </div>
                <!-- /.row -->
                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content -->
            <!-- /.content-wrapper -->

        </div>
        <!-- /.content-wrapper -->
        <app-footer></app-footer>
    </div>
    <!-- ./wrapper -->
</div>
<div class="modal fade" id="modal-delete">
    <div class="modal-dialog">
      <div class="modal-content bg-secondary">
        <div class="modal-header">
          <h4 class="modal-title">Delete Area</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p [innerHTML]="'This action will remove '+areaName+'. This action is not reversable, are you sure you want to continue ?'"></p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-outline-light" (click)="deleteArea(areaRef)">Delete Area</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
